import { render } from "./LoanDetailsModal.vue?vue&type=template&id=d8824086&scoped=true"
import script from "./LoanDetailsModal.vue?vue&type=script&lang=js"
export * from "./LoanDetailsModal.vue?vue&type=script&lang=js"

import "./LoanDetailsModal.vue?vue&type=style&index=0&id=d8824086&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8824086"]])

export default __exports__